import { statusDisplayNameForTrackings } from '@rsos/constants/alertStatuses';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const ALERT_QUEUE_EVENT_NAMES = {
  CLICK_SUPPLEMENTAL_ALERT: 'click_supplemental_alert',
  CLICK_CANCELED_SUPPLEMENTAL_ALERT: 'click_canceled_supplemental_alert',
  CLICK_ALERT: 'click_alert',
  CLICK_ALERT_UNREAD: 'click_alert_with_unread_indicator',
};

export const trackClickAlert = (
  alertStatus,
  appName,
  isSupplementalAlert = false,
  isUnread = false,
  selectedAlertID,
  irpVersion,
) => {
  let displayAppName = 'RSP';
  if (appName === 'central_station') {
    displayAppName = 'CSP';
  }
  let displayStatus = statusDisplayNameForTrackings[alertStatus];

  if (isSupplementalAlert) {
    gspx.trackEvent({
      name: ALERT_QUEUE_EVENT_NAMES.CLICK_SUPPLEMENTAL_ALERT,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.CALL_QUEUE,
      additionalKeys: {
        legacy_category: 'Alert',
        legacy_name: `Click supplemental Alert in ${displayAppName}`,
        Category: 'Alert',
        'Launched date': new Date(),
        irpVersion,
      },
      entities: {
        alert_id: selectedAlertID,
      },
    });
    if (alertStatus === 'CANCELED') {
      gspx.trackEvent({
        name: ALERT_QUEUE_EVENT_NAMES.CLICK_CANCELED_SUPPLEMENTAL_ALERT,
        type: GPX_EVENT_TYPES.INFO,
        feature: GPX_FEATURES.LEGACY,
        capability: GPX_CAPABILITIES.LEGACY,
        route: GPX_ROUTES.CALL_QUEUE,
        additionalKeys: {
          legacy_category: 'Alert',
          legacy_name: `Click Canceled Alert (supplemental) in  ${displayAppName}`,
          Category: 'Alert',
          'Launched date': new Date(),
          irpVersion,
        },
        entities: {
          alert_id: selectedAlertID,
        },
      });
    }
  } else {
    if (displayAppName === 'RSP' && alertStatus === 'DISPATCH_REQUESTED') {
      displayStatus = 'New';
    }

    gspx.trackEvent({
      name: ALERT_QUEUE_EVENT_NAMES.CLICK_ALERT,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.CALL_QUEUE,
      additionalKeys: {
        legacy_category: 'Alert',
        legacy_name: `Click ${displayStatus} Alert in ${displayAppName}`,
        Category: 'Alert',
        'Launched date': new Date(),
        irpVersion,
      },
      entities: {
        alert_id: selectedAlertID,
      },
    });
  }
  if (isUnread) {
    gspx.trackEvent({
      name: ALERT_QUEUE_EVENT_NAMES.CLICK_ALERT_UNREAD,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.CALL_QUEUE,
      additionalKeys: {
        legacy_category: 'Alert',
        legacy_name: `Click ${displayStatus} Alert with unread indicator in ${displayAppName}`,
        Category: 'Alert',
        'Launched date': new Date(),
        irpVersion,
      },
      entities: {
        alert_id: selectedAlertID,
      },
    });
  }
};
